import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import{IContractorReview, IContractorReviewInput,  saveContractorReview, GetContractorReviewByIds, IContractorReviewResponseInput, saveContractorReviewResponse } from '@ebb-v2/ebb-integration'
import { map, take } from 'rxjs/operators';
import { Apollo } from 'apollo-angular';
@Injectable({
    providedIn: 'root'
  })
  export class ContractorReviewApiService  {
  
    constructor(
      private apollo: Apollo
    ) { }
    
    public getContractorReview(applicationid: string,contractorid: string): Observable<IContractorReview> {
      console.log(`ContractorReviewApiService.getContractorReview()`);
      return this.apollo
        .watchQuery({
          query: GetContractorReviewByIds,
          variables: {
            applicationid:applicationid,
            contractorid:contractorid
          },
          fetchPolicy: 'network-only'
        })
        .valueChanges
        .pipe(map(result => result.data['contractorReviewByIds'] as IContractorReview), take(1));   
    }
  
    public saveContractorReview(contractorReviewInput: IContractorReviewInput,contractorReviewId:string) : Observable<IContractorReview> {
      console.log(`ContractorReviewApiService.saveContractorReview`);
      return this.apollo
        .mutate({
          mutation: saveContractorReview,
          variables : {
            contractorReviewInput,contractorReviewId
          }
        })
        .pipe(map(result => result.data['saveContractorReview'] as IContractorReview));
    }
    public saveContractorReviewResponse(contractorReviewResponseInput: IContractorReviewResponseInput,contractorReviewId:string) : Observable<IContractorReview> {
      console.log(`ContractorReviewApiService.saveContractorReviewResponse`);
      return this.apollo
        .mutate({
          mutation: saveContractorReviewResponse,
          variables : {
            contractorReviewResponseInput,contractorReviewId
          }
        })
        .pipe(map(result => result.data['saveContractorReviewResponse'] as IContractorReview));
    }
  }
  // export abstract class ContractorReviewApiService {
     
  

  //   abstract getContractorReview(applicationid: string,contractorid:string): Observable<IContractorReview>;
  
  //   abstract saveContractorReview(contractorreview: IContractorReviewInput,contractorReviewId:string): Observable<any>;
  
  // }